import { useEffect, useState } from "react";
import { collection, query, where, getDocs} from "firebase/firestore";
import { db, auth } from "../../utils/firebase";
import PageLoader from "../../components/loaders/page-loader.component";
import NoPaymentHistoryScreen from "./params/no-payment-history.screen";
import PropertyHistoryList from "./params/payment-history-list.screen";

const PaymentHistoryScreen = () => {
  document.title = "Payment History";
  const [transactionList, setTransactionList] = useState([]);
  const [loader, setLoader] = useState(true);
  const myUid = auth.currentUser?.uid;

  const fetchBookings = async () => {
    setLoader(true);
    try {
      if (!myUid) return;

      const bookingsRef = collection(db, "paymentEntries");
      
      const qTenant = query(bookingsRef, where("userId", "==", myUid));
      const qOwner = query(bookingsRef, where("receiverID", "==", myUid));

      const [tenantSnap, ownerSnap] = await Promise.all([
        getDocs(qTenant),
        getDocs(qOwner)
      ]);

      const allBookingsMap = new Map();
      
      tenantSnap.docs.forEach(doc => {
        allBookingsMap.set(doc.id, { id: doc.id, ...doc.data() });
      });
      
      ownerSnap.docs.forEach(doc => {
        allBookingsMap.set(doc.id, { id: doc.id, ...doc.data() });
      });

      const combinedBookings = Array.from(allBookingsMap.values());
      combinedBookings.sort((a, b) => b.createdAt?.toMillis() - a.createdAt?.toMillis());
      
      setTransactionList(combinedBookings);
    } catch (error) {
      console.error("Error fetching bookings:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, [myUid]);



  return (
    <>
      {loader ? (
        <PageLoader
          size="150px"
          className="p-10 w-full flex justify-center"
        />
      ) : transactionList.length === 0 ? (
        <NoPaymentHistoryScreen />
      ) : (
        <PropertyHistoryList 
          data={transactionList} 
          myUid={myUid}
        />
      )}
    </>
  );
};

export default PaymentHistoryScreen;